import { render, staticRenderFns } from "./W3.vue?vue&type=template&id=64eaacbe&scoped=true&"
import script from "./W3.vue?vue&type=script&lang=js&"
export * from "./W3.vue?vue&type=script&lang=js&"
import style0 from "./W3.vue?vue&type=style&index=0&id=64eaacbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64eaacbe",
  null
  
)

export default component.exports